var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6206 2.61328H7.03727C4.39227 2.61328 2.24561 4.75036 2.24561 7.38578V13.1166V14.0749C2.24561 16.7104 4.39227 18.8474 7.03727 18.8474H8.47477C8.73352 18.8474 9.07852 19.0199 9.24144 19.2308L10.6789 21.1379C11.3114 21.9812 12.3464 21.9812 12.9789 21.1379L14.4164 19.2308C14.5985 18.9912 14.886 18.8474 15.1831 18.8474H16.6206C19.2656 18.8474 21.4123 16.7104 21.4123 14.0749V7.38578C21.4123 4.75036 19.2656 2.61328 16.6206 2.61328ZM7.99561 12.1966C7.45894 12.1966 7.03727 11.7654 7.03727 11.2383C7.03727 10.7112 7.46852 10.2799 7.99561 10.2799C8.52269 10.2799 8.95394 10.7112 8.95394 11.2383C8.95394 11.7654 8.53227 12.1966 7.99561 12.1966ZM11.8289 12.1966C11.2923 12.1966 10.8706 11.7654 10.8706 11.2383C10.8706 10.7112 11.3019 10.2799 11.8289 10.2799C12.356 10.2799 12.7873 10.7112 12.7873 11.2383C12.7873 11.7654 12.3656 12.1966 11.8289 12.1966ZM15.6623 12.1966C15.1256 12.1966 14.7039 11.7654 14.7039 11.2383C14.7039 10.7112 15.1352 10.2799 15.6623 10.2799C16.1894 10.2799 16.6206 10.7112 16.6206 11.2383C16.6206 11.7654 16.1989 12.1966 15.6623 12.1966Z",
    fill: "url(#paint0_linear_3779_18313)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3779_18313",
    x1: 11.8289,
    y1: 2.61328,
    x2: 11.8289,
    y2: 21.7704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01D5EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0166FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.c622743c7ae15173cf6904e774fd814c.svg";
export { ForwardRef as ReactComponent };